import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 26.48 19.26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.48 19.26\" id=\"icon-share\"><g id=\"icon-share_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-share_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M14.17,4.75l.87,0V.6a.6.6,0,0,1,1-.46L26.26,8.56a.6.6,0,0,1,0,.93L16,17.92a.6.6,0,0,1-1-.47V13.11a15.65,15.65,0,0,0-3.31-.35A11.38,11.38,0,0,0,1.13,18.94a.6.6,0,0,1-.53.32l-.15,0A.6.6,0,0,1,0,18.66C0,5.75,10.85,4.75,14.17,4.75Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol